import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>AIplify</h3>
          <p> London | Tokyo | Copenhagen | Brussels </p>
        </div>
        <div className="footer-section">
          <h3>Contact us</h3>
          <p>contact@aiplify.eu</p>
        </div>
        <div className="footer-section">
          <h3>Our Terms</h3>
          <a href="/privacy-policy" className="footer-link">Privacy policy</a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2025 AIplify</p>
      </div>
    </footer>
  );
};

export default Footer;
